document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.createNotificationController !== 'function') {
    return;
  }

  var restoreButton = document.getElementById('notification-example-restore');
  var status = document.getElementById('notification-example-status');
  var controller = window.createNotificationController({
    root: document
  });

  function updateStatus() {
    var totalCount = controller.getNotifications().length;
    var closedCount = controller.getDismissedNotifications().length;
    var visibleCount = totalCount - closedCount;

    if (!status) {
      return;
    }

    status.textContent = closedCount + ' closed, ' + visibleCount + ' visible.';
  }

  if (restoreButton) {
    restoreButton.addEventListener('click', function () {
      controller.restoreAll();
      updateStatus();
    });
  }

  document.addEventListener('notification:dismissed', updateStatus);
  document.addEventListener('notification:restored', updateStatus);
  document.addEventListener('notification:restored-all', updateStatus);

  updateStatus();
});
